export default __webpack_public_path__ + "static/media/Mortgageblack.7b2acbd4.svg";